/* ==========================================================================
   ROADNEST — theme JS (vanilla, no dependencies)
   Cart drawer, product form, variant picker, header, lightbox, reveal.
   Product media gallery lives in assets/product-gallery.js.
   ========================================================================== */
(function () {
  'use strict';

  var R = window.RoadnestRoutes || {};
  var S = window.RoadnestStrings || {};

  window.Roadnest = window.Roadnest || {};
  var track = function (name, data) {
    if (window.Roadnest && typeof window.Roadnest.track === 'function') {
      window.Roadnest.track(name, data);
    }
  };

  var qs = function (sel, scope) { return (scope || document).querySelector(sel); };
  var qsa = function (sel, scope) { return Array.prototype.slice.call((scope || document).querySelectorAll(sel)); };
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function formatMoney(cents, fallback) {
    if (typeof cents !== 'number') return fallback || '';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', {
        style: 'currency',
        currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR',
        minimumFractionDigits: cents % 100 === 0 ? 0 : 2
      }).format(cents / 100);
    } catch (err) {
      return fallback || '';
    }
  }

  /* ---------------- Cart ---------------- */

  var cartCache = null;

  function fetchCart() {
    return fetch((R.cart || '/cart') + '.js', { headers: { 'Cache-Control': 'no-store' } })
      .then(function (res) { return res.json(); });
  }

  function updateCartCount(count) {
    qsa('[data-cart-count]').forEach(function (el) {
      el.textContent = count > 99 ? '99+' : String(count);
      el.hidden = count === 0;
    });
  }

  function replaceDrawerSection(html) {
    if (!html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = qs('[data-cart-drawer-content]', doc);
    var current = qs('[data-cart-drawer-content]');
    if (fresh && current) {
      current.innerHTML = fresh.innerHTML;
      bindDrawerNote();
    }
  }

  function refreshDrawer() {
    return fetch((R.root || '/') + '?sections=cart-drawer', { headers: { 'Cache-Control': 'no-store' } })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        replaceDrawerSection(data['cart-drawer']);
        return fetchCart();
      })
      .then(function (cart) {
        cartCache = cart;
        updateCartCount(cart.item_count);
        return cart;
      })
      .catch(function () {});
  }

  /* ---------------- Drawers ---------------- */

  var lastFocused = null;

  function openDrawer(el) {
    if (!el) return;
    lastFocused = document.activeElement;
    el.setAttribute('data-open', '');
    document.body.classList.add('no-scroll');
    var focusTarget = qs('[data-autofocus]', el) || qs('button, a[href]', el);
    if (focusTarget) focusTarget.focus();
  }

  function closeDrawer(el) {
    if (!el) return;
    el.removeAttribute('data-open');
    if (!qs('.cart-drawer[data-open], .mobile-nav[data-open]')) {
      document.body.classList.remove('no-scroll');
    }
    if (lastFocused && document.contains(lastFocused)) lastFocused.focus();
  }

  function initDrawers() {
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-nav-toggle]')) {
        openDrawer(qs('#MobileNav'));
        return;
      }
      var cartToggle = e.target.closest('[data-cart-toggle]');
      if (cartToggle) {
        e.preventDefault();
        var drawer = qs('#CartDrawer');
        if (!drawer) { window.location.href = R.cart || '/cart'; return; }
        if (drawer.hasAttribute('data-open')) {
          closeDrawer(drawer);
        } else {
          openDrawer(drawer);
          track('view_cart');
          refreshDrawer();
        }
        return;
      }
      if (e.target.closest('[data-drawer-close]')) {
        closeDrawer(e.target.closest('.cart-drawer, .mobile-nav'));
        return;
      }
      var scrim = e.target.closest('[data-scrim]');
      if (scrim) closeDrawer(scrim.closest('.cart-drawer, .mobile-nav'));
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      qsa('.cart-drawer[data-open], .mobile-nav[data-open]').forEach(closeDrawer);
    });

    document.addEventListener('click', function (e) {
      var link = e.target.closest('.mobile-nav__links a, .mobile-nav__foot a');
      if (link) closeDrawer(qs('#MobileNav'));
    });
  }

  /* ---------------- Header ---------------- */

  function initHeader() {
    var header = qs('[data-header]');
    if (!header) return;
    var overlay = header.classList.contains('header--overlay');
    var lastY = window.scrollY;
    var threshold = 12;

    var onScroll = function () {
      var y = window.scrollY;
      header.classList.toggle('is-solid', y > threshold);
      if (overlay) {
        var goingDown = y > lastY && y > 240;
        var navOpen = !!qs('.mobile-nav[data-open], .cart-drawer[data-open]');
        header.classList.toggle('is-hidden', goingDown && !navOpen);
      }
      lastY = y;
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------------- Cart mutations ---------------- */

  function setPending(el, pending) {
    if (!el) return;
    if (pending) {
      el.setAttribute('data-pending', '');
      el.setAttribute('aria-busy', 'true');
      if (el.tagName === 'BUTTON' || el.tagName === 'INPUT') {
        el.setAttribute('data-pending-was-disabled', el.disabled ? 'true' : 'false');
        el.setAttribute('disabled', 'disabled');
      }
      else el.setAttribute('aria-disabled', 'true');
    } else {
      el.removeAttribute('data-pending');
      el.removeAttribute('aria-busy');
      if (el.tagName === 'BUTTON' || el.tagName === 'INPUT') {
        if (el.getAttribute('data-pending-was-disabled') !== 'true') el.removeAttribute('disabled');
        el.removeAttribute('data-pending-was-disabled');
      }
      else el.removeAttribute('aria-disabled');
    }
  }

  function cartChange(id, quantity) {
    return fetch(R.cartChange || '/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: id, quantity: quantity, sections: 'cart-drawer' })
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        replaceDrawerSection(data.sections ? data.sections['cart-drawer'] : null);
        return refreshDrawer();
      });
  }

  function initCartMutations() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-line-qty], [data-line-remove]');
      if (!btn) return;
      e.preventDefault();
      if (btn.hasAttribute('data-pending')) return;
      var lineEl = btn.closest('[data-line-key]');

      if (!lineEl) {
        var wrap = btn.closest('.qty');
        var localQty = wrap ? qs('[data-qty-input]', wrap) : null;
        if (!localQty) return;
        var cur = parseInt(localQty.value, 10) || 1;
        if (btn.hasAttribute('data-line-plus')) cur = Math.min(9, cur + 1);
        else if (btn.hasAttribute('data-line-minus')) cur = Math.max(1, cur - 1);
        localQty.value = cur;
        return;
      }

      var key = lineEl.getAttribute('data-line-key');
      var input = qs('[data-qty-input]', lineEl);
      var currentQty = input ? parseInt(input.value, 10) || 1 : 1;
      var newQty = currentQty;
      if (btn.hasAttribute('data-line-remove')) newQty = 0;
      else if (btn.hasAttribute('data-line-minus')) newQty = Math.max(0, currentQty - 1);
      else if (btn.hasAttribute('data-line-plus')) newQty = currentQty + 1;

      setPending(btn, true);
      cartChange(key, newQty).finally(function () { setPending(btn, false); });
    });

    document.addEventListener('change', function (e) {
      var input = e.target.closest('[data-qty-input][data-live]');
      if (!input) return;
      var lineEl = input.closest('[data-line-key]');
      if (!lineEl) return;
      setPending(input, true);
      cartChange(lineEl.getAttribute('data-line-key'), Math.max(0, parseInt(input.value, 10) || 0))
        .finally(function () { setPending(input, false); });
    });

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-checkout]')) track('begin_checkout', buildEcommerce(cartCache));
    });

    bindDrawerNote();
  }

  function bindDrawerNote() {
    var toggle = qs('[data-note-toggle]');
    if (toggle && !toggle.hasAttribute('data-bound')) {
      toggle.setAttribute('data-bound', '');
      toggle.addEventListener('click', function () {
        var wrap = qs('[data-note-wrap]');
        if (wrap) wrap.hidden = !wrap.hidden;
      });
    }
    var noteInput = qs('[data-cart-note]');
    if (noteInput && !noteInput.hasAttribute('data-bound')) {
      noteInput.setAttribute('data-bound', '');
      noteInput.addEventListener('change', function () {
        fetch(R.cartUpdate || '/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ note: noteInput.value })
        });
      });
    }
  }

  function buildEcommerce(cart) {
    var data = { currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR' };
    if (cart && cart.items) {
      data.value = cart.total_price / 100;
      data.items = cart.items.map(function (i) {
        return { item_id: i.sku || i.product_id, item_name: i.product_title, price: i.final_price / 100, quantity: i.quantity };
      });
    }
    return data;
  }

  /* ---------------- Add to cart ---------------- */

  function initProductForms() {
    function productErrorTarget(form, trigger) {
      var section = trigger && trigger.closest ? trigger.closest('section') : null;
      return (section && qs('[data-direct-checkout-error]', section)) || qs('[data-cart-error]', form);
    }

    function showProductError(form, trigger, err) {
      var msg = productErrorTarget(form, trigger);
      if (!msg) return;
      msg.textContent = (err && err.message) || (S.error || 'Une erreur est survenue.');
      msg.hidden = false;
      msg.focus({ preventScroll: true });
      msg.scrollIntoView({ block: 'center', behavior: reduceMotion.matches ? 'auto' : 'smooth' });
    }

    function directCheckout(form, trigger) {
      if (form.hasAttribute('data-pending')) return;

      var mainButton = qs('[data-direct-checkout]', form);
      var error = productErrorTarget(form, trigger);
      form.setAttribute('data-pending', '');
      setPending(trigger, true);
      if (mainButton !== trigger) setPending(mainButton, true);
      if (error) { error.hidden = true; error.textContent = ''; }

      var body = new FormData(form);
      body.delete('return_to');

      fetch(R.cartAdd || '/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: body
      })
        .then(function (res) {
          return res.json().catch(function () { return {}; }).then(function (data) {
            if (!res.ok || data.status) throw new Error(data.description || data.message || S.error || 'Une erreur est survenue.');
            return data;
          });
        })
        .then(function (data) {
          track('add_to_cart', {
            currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR',
            items: [{ item_id: data.sku || data.variant_id, item_name: data.product_title, price: (data.final_price || 0) / 100, quantity: data.quantity }]
          });
          window.location.assign(R.checkout || '/checkout');
        })
        .catch(function (err) {
          form.removeAttribute('data-pending');
          setPending(trigger, false);
          if (mainButton !== trigger) setPending(mainButton, false);
          showProductError(form, trigger, err);
        });
    }

    /* Own only ROADNEST direct-checkout forms. Capture prevents cart-drawer
       listeners from handling the same submit; Essential Sticky Cart has
       different markup and is never selected here. */
    document.addEventListener('submit', function (e) {
      var stickyForm = e.target.closest('[data-sticky-atc-form]');
      if (stickyForm) {
        e.preventDefault();
        e.stopImmediatePropagation();
        var mainForm = qs('[data-product-form]');
        if (!mainForm || mainForm.hasAttribute('data-pending')) return;
        mainForm._roadnestCheckoutTrigger = e.submitter || qs('[type="submit"]', stickyForm);
        if (typeof mainForm.requestSubmit === 'function') mainForm.requestSubmit();
        else mainForm.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
        return;
      }

      var directForm = e.target.closest('[data-product-form]');
      if (!directForm || !directForm.querySelector('[data-direct-checkout]')) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      var directTrigger = directForm._roadnestCheckoutTrigger || e.submitter || qs('[data-direct-checkout]', directForm);
      directForm._roadnestCheckoutTrigger = null;
      directCheckout(directForm, directTrigger);
    }, true);

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-theme-checkout-trigger]');
      if (!trigger) return;
      e.preventDefault();
      if (trigger.hasAttribute('data-pending')) return;
      var form = qs('[data-product-form]');
      if (!form || form.hasAttribute('data-pending')) return;
      form._roadnestCheckoutTrigger = trigger;
      if (typeof form.requestSubmit === 'function') form.requestSubmit();
      else form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
    });

    /* Cart-mode product forms keep the existing drawer behaviour. */
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-product-form]');
      if (!form) return;
      if (form.querySelector('[data-direct-checkout]')) return;
      e.preventDefault();
      if (form.hasAttribute('data-pending')) return;

      var button = form.querySelector('[type="submit"]');
      var label = button ? button.innerHTML : '';
      form.setAttribute('data-pending', '');
      if (button) { button.disabled = true; button.textContent = S.adding || 'Ajout…'; }

      var body = new FormData(form);
      body.append('sections', 'cart-drawer');

      fetch(R.cartAdd || '/cart/add.js', { method: 'POST', body: body })
        .then(function (res) { return res.json(); })
        .then(function (data) {
          if (data.status) throw new Error(data.description || data.message);
          replaceDrawerSection(data.sections ? data.sections['cart-drawer'] : null);
          fetchCart().then(function (cart) {
            cartCache = cart;
            updateCartCount(cart.item_count);
          }).catch(function () {});
          var drawer = qs('#CartDrawer');
          track('add_to_cart', {
            currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR',
            items: [{ item_id: data.sku || data.variant_id, item_name: data.product_title, price: (data.final_price || 0) / 100, quantity: data.quantity }]
          });
          if (drawer) {
            openDrawer(drawer);
            track('view_cart');
          } else {
            window.location.href = R.cart || '/cart';
          }
        })
        .catch(function (err) {
          var msg = qs('[data-cart-error]', form);
          if (msg) { msg.textContent = (err && err.message) || (S.error || 'Une erreur est survenue.'); msg.hidden = false; }
        })
        .finally(function () {
          form.removeAttribute('data-pending');
          if (button) { button.disabled = false; button.innerHTML = label; }
        });
    });

  }

  /* ---------------- Variant picker ---------------- */

  var boundSections = new WeakSet();

  function initVariantPickers(scope) {
    qsa('[data-product-section]', scope || document).forEach(function (section) {
      // WeakSet, not an attribute: attributes survive the Theme Editor's
      // wholesale markup replacement and would block re-binding.
      if (boundSections.has(section)) return;
      boundSections.add(section);

      var jsonEl = qs('[data-variants-json]', section);
      if (!jsonEl) return;
      var variants;
      try { variants = JSON.parse(jsonEl.textContent); } catch (err) { return; }
      if (!variants || !variants.length) return;

      var radios = qsa('[data-variant-radio]', section);
      var select = qs('[data-variant-select]', section);
      var form = qs('[data-product-form]', section);
      var idInput = form ? form.querySelector('input[name="id"]') : null;
      var buyButton = qs('[data-add-button]', section);
      var gallery = qs('product-gallery', section);
      var priceWrap = qs('[data-price-block]', section);
      var stickyId = qs('[data-sticky-id]');
      var showCompare = section.getAttribute('data-show-compare') !== 'false';

      function render(v, silent) {
        if (!v) return;
        if (idInput) idInput.value = v.id;
        if (stickyId) stickyId.value = v.id;

        if (priceWrap) {
          var discounted = showCompare && v.compare_at_price && v.compare_at_price > v.price;
          var html = '<span class="price">';
          html += '<span class="price__current">' + v.price_formatted + '</span>';
          if (discounted) {
            html += '<s class="price__compare">' + v.compare_at_formatted + '</s>';
          }
          html += '</span>';
          if (discounted && v.saved_formatted) {
            html += '<span class="savings">' + (S.save || 'Économisez') + ' ' + v.saved_formatted + '</span>';
          }
          priceWrap.innerHTML = html;
        }

        qsa('[data-final-price]').forEach(function (finalPrice) {
          var finalHtml = '<span class="price"><span class="price__current">' + v.price_formatted + '</span>';
          if (showCompare && v.compare_at_price && v.compare_at_price > v.price) {
            finalHtml += '<s class="price__compare">' + v.compare_at_formatted + '</s>';
          }
          finalPrice.innerHTML = finalHtml + '</span>';
        });

        qsa('[data-variant-price]').forEach(function (el) { el.textContent = v.price_formatted; });
        if (v.installment_formatted) {
          qsa('[data-installment-price]').forEach(function (el) { el.textContent = v.installment_formatted; });
        }

        if (buyButton) {
          var labelEl = qs('[data-add-label]', buyButton);
          if (labelEl && !labelEl.dataset.defaultLabel) {
            labelEl.dataset.defaultLabel = labelEl.textContent.trim();
          }
          buyButton.disabled = !v.available;
          if (labelEl) {
            labelEl.textContent = v.available
              ? (labelEl.dataset.defaultLabel || S.addToCart || 'Ajouter au panier')
              : (S.soldOut || 'Épuisé');
          }
        }
        qsa('[data-sticky-atc] button[type="submit"]').forEach(function (btn) {
          if (!btn.dataset.defaultLabel) btn.dataset.defaultLabel = btn.textContent.trim();
          btn.disabled = !v.available;
          btn.textContent = v.available
            ? (btn.dataset.defaultLabel || S.addToCart || 'Ajouter au panier')
            : (S.soldOut || 'Épuisé');
        });

        if (gallery && v.media_id && typeof gallery.selectMedia === 'function') {
          gallery.selectMedia(v.media_id);
        }

        if (silent) return;
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        } catch (err) {}
      }

      function selectedId() {
        for (var i = 0; i < radios.length; i++) {
          if (radios[i].checked) return radios[i].value;
        }
        if (select) return select.value;
        return idInput ? idInput.value : null;
      }

      function find(id) {
        for (var i = 0; i < variants.length; i++) {
          if (variants[i].id === Number(id)) return variants[i];
        }
        return null;
      }

      radios.forEach(function (radio) {
        radio.addEventListener('change', function () {
          if (radio.checked) render(find(radio.value));
        });
      });

      if (select) {
        select.addEventListener('change', function () { render(find(select.value)); });
      }

      // Reconcile the form with whatever variant is actually selected. After a
      // Theme Editor re-render or a bfcache restore the hidden input and the
      // checked radio can disagree — which would add the wrong variant to cart.
      render(find(selectedId()), true);
    });
  }

  /* ---------------- Sticky add-to-cart ---------------- */

  var boundSentinels = new WeakSet();

  function initStickyAtc() {
    var bar = qs('[data-sticky-atc]');
    var sentinel = qs('[data-sticky-sentinel]');
    if (!bar || !sentinel || !('IntersectionObserver' in window)) return;
    if (boundSentinels.has(sentinel)) return;
    boundSentinels.add(sentinel);
    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var past = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        if (past) bar.setAttribute('data-visible', '');
        else bar.removeAttribute('data-visible');
      });
    }, { threshold: 0 }).observe(sentinel);
  }

  /* ---------------- Lightbox ---------------- */

  var lightbox = null;

  function buildLightbox() {
    if (lightbox) return lightbox;
    lightbox = document.createElement('div');
    lightbox.className = 'lightbox';
    lightbox.setAttribute('role', 'dialog');
    lightbox.setAttribute('aria-modal', 'true');
    lightbox.innerHTML =
      '<button type="button" class="lightbox__close" aria-label="' + (S.close || 'Fermer') + '">' +
      '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg>' +
      '</button><img alt=""><p class="lightbox__caption"></p>';
    document.body.appendChild(lightbox);
    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox || e.target.closest('.lightbox__close')) closeLightbox();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && lightbox.hasAttribute('data-open')) closeLightbox();
    });
    return lightbox;
  }

  function closeLightbox() {
    if (!lightbox) return;
    lightbox.removeAttribute('data-open');
    document.body.classList.remove('no-scroll');
    if (lastFocused && document.contains(lastFocused)) lastFocused.focus();
  }

  window.Roadnest.openLightbox = function (src, alt) {
    if (!src) return;
    var box = buildLightbox();
    lastFocused = document.activeElement;
    var img = qs('img', box);
    var caption = qs('.lightbox__caption', box);
    img.src = src;
    img.alt = alt || '';
    if (caption) caption.textContent = alt || '';
    box.setAttribute('data-open', '');
    document.body.classList.add('no-scroll');
    var close = qs('.lightbox__close', box);
    if (close) close.focus();
  };

  function initZoomTriggers() {
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-zoom-trigger]');
      if (!trigger) return;
      e.preventDefault();
      var wrap = trigger.closest('[data-zoom-scope]') || document;
      var img = trigger.hasAttribute('data-zoom-src') ? trigger : qs('img', wrap);
      if (!img) return;
      var src = img.getAttribute('data-zoom-src') || img.currentSrc || img.src;
      window.Roadnest.openLightbox(src, img.getAttribute('alt') || '');
    });
  }

  /* ---------------- Compatibility modal ---------------- */

  function initCompatibility() {
    var dialog = qs('[data-compat-modal]');
    if (!dialog) return;

    var fieldsPanel = qs('[data-compat-fields]', dialog);
    var successPanel = qs('[data-compat-success]', dialog);
    var contextPanel = qs('[data-compat-context]', dialog);
    var contextTitle = qs('[data-compat-context-title]', dialog);
    var vehicleFields = qsa('[data-compat-vehicle-field]', dialog);
    var productField = qs('[data-compat-product-field]', dialog);
    var productSelect = qs('[data-compat-product]', dialog);
    var configField = qs('[data-compat-config-field]', dialog);
    var configLabel = qs('[data-compat-config-label]', dialog);
    var configSelect = qs('[data-compat-config]', dialog);
    var bodyInput = qs('[data-compat-body]', dialog);
    var resultInput = qs('[data-compat-result]', dialog);
    var reasonInput = qs('[data-compat-reason]', dialog);

    function setSelectOptions(select, options, selected) {
      if (!select) return;
      select.innerHTML = '<option value="">Choisir</option>' + options.map(function (option) {
        return '<option value="' + option.value + '"' + (selected === option.value ? ' selected' : '') + '>' + option.label + '</option>';
      }).join('');
    }

    function configureProductOptions(product, hatch) {
      if (product === 'nomad' || product === 'Roadnest Nomad') {
        if (configLabel) configLabel.textContent = 'Ouverture du hayon';
        var hatchValue = hatch === 'yes' ? 'Hayon vers le haut' : (hatch === 'no' ? 'Autre ouverture' : (hatch === 'unknown' ? 'Je ne sais pas' : ''));
        setSelectOptions(configSelect, [
          { value: 'Hayon vers le haut', label: 'Hayon vers le haut' },
          { value: 'Autre ouverture', label: 'Autre ouverture' },
          { value: 'Je ne sais pas', label: 'Je ne sais pas' }
        ], hatchValue);
      } else {
        if (configLabel) configLabel.textContent = 'Type de toit (si connu)';
        setSelectOptions(configSelect, [
          { value: 'Barres transversales', label: 'Barres transversales' },
          { value: 'Rails longitudinaux', label: 'Rails longitudinaux' },
          { value: 'Plateforme de toit', label: 'Plateforme de toit' },
          { value: 'Toit nu', label: 'Toit nu' },
          { value: 'Je ne sais pas', label: 'Je ne sais pas' }
        ], '');
      }
    }

    function configureRequest(context) {
      var hasContext = context && context.brand && context.model && context.year && context.product;
      vehicleFields.forEach(function (field) { field.hidden = Boolean(hasContext); });
      if (productField) productField.hidden = Boolean(hasContext);
      if (configField) configField.hidden = Boolean(hasContext);
      if (contextPanel) contextPanel.hidden = !hasContext;
      if (hasContext) {
        var productName = context.product === 'nomad' ? 'Roadnest Nomad' : 'Roadnest Summit';
        if (contextTitle) contextTitle.textContent = productName + ' · ' + context.brand + ' ' + context.model + ' · ' + context.year;
        var brandInput = qs('#CompatMarque', dialog);
        var modelInput = qs('#CompatModele', dialog);
        var yearInput = qs('#CompatAnnee', dialog);
        if (brandInput) brandInput.value = context.brand;
        if (modelInput) modelInput.value = context.model;
        if (yearInput) yearInput.value = context.year;
        if (productSelect) productSelect.value = productName;
        if (bodyInput) bodyInput.value = context.body || '';
        if (resultInput) resultInput.value = context.result || '';
        if (reasonInput) reasonInput.value = context.reason || '';
        configureProductOptions(context.product, context.hatch);
      } else {
        if (bodyInput) bodyInput.value = '';
        if (resultInput) resultInput.value = '';
        if (reasonInput) reasonInput.value = '';
      }
    }

    function showSuccess() {
      if (fieldsPanel) fieldsPanel.hidden = true;
      if (successPanel) successPanel.hidden = false;
    }
    function resetPanel() {
      if (fieldsPanel) fieldsPanel.hidden = false;
      if (successPanel) successPanel.hidden = true;
      if (form) form.reset();
      configureRequest(null);
      configureProductOptions(productSelect ? productSelect.value : 'summit');
    }

    window.Roadnest.compat = {
      open: function (context) {
        configureRequest(context || null);
        if (typeof dialog.showModal === 'function') dialog.showModal();
        else dialog.setAttribute('open', '');
        document.body.classList.add('no-scroll');
        track('compatibility_open', context || {});
      },
      openWithSuccess: function () { this.open(); showSuccess(); }
    };

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-open-compatibility]')) {
        e.preventDefault();
        var trigger = e.target.closest('[data-open-compatibility]');
        var context = null;
        if (trigger.dataset.compatBrand) {
          context = {
            product: trigger.dataset.compatProduct,
            brand: trigger.dataset.compatBrand,
            model: trigger.dataset.compatModel,
            year: trigger.dataset.compatYear,
            body: trigger.dataset.compatBody,
            result: trigger.dataset.compatResult,
            reason: trigger.dataset.compatReason,
            hatch: trigger.dataset.compatHatch
          };
        }
        window.Roadnest.compat.open(context);
        return;
      }
      if (e.target.closest('[data-compat-close]')) { dialog.close(); return; }
      if (e.target === dialog) dialog.close();
    });

    dialog.addEventListener('close', function () {
      document.body.classList.remove('no-scroll');
      setTimeout(resetPanel, 250);
    });

    if (new URLSearchParams(window.location.search).has('contact_posted')) {
      window.Roadnest.compat.openWithSuccess();
      track('compatibility_submit');
    }

    var form = qs('[data-compat-form]', dialog);
    if (form) {
      if (productSelect) productSelect.addEventListener('change', function () { configureProductOptions(productSelect.value); });
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var submitBtn = form.querySelector('[type="submit"]');
        setPending(submitBtn, true);
        fetch(form.action, { method: 'POST', body: new FormData(form), redirect: 'follow' })
          .then(function (res) {
            if (res.url && res.url.indexOf('contact_posted=true') !== -1) {
              showSuccess();
              track('compatibility_submit');
              form.reset();
              return null;
            }
            throw new Error('submission failed');
          })
          .catch(function () {
            form.removeAttribute('novalidate');
            form.submit();
          })
          .finally(function () { setPending(submitBtn, false); });
      });
    }
  }

  /* ---------------- Reveal ---------------- */

  function initReveal(scope) {
    var els = qsa('.reveal', scope || document).filter(function (el) { return !el.classList.contains('is-visible'); });
    if (!els.length) return;
    if (reduceMotion.matches || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.06 });
    els.forEach(function (el) { observer.observe(el); });
  }

  /* ---------------- Accessible footer accordions ---------------- */

  function initFooter(scope) {
    qsa('[data-footer]', scope || document).forEach(function (footer) {
      if (footer.hasAttribute('data-footer-bound')) return;
      footer.setAttribute('data-footer-bound', '');
      var groups = qsa('.footer__group', footer);
      var compact = window.matchMedia('(max-width: 699px)');
      function sync() {
        groups.forEach(function (group) {
          if (compact.matches) group.removeAttribute('open');
          else group.setAttribute('open', '');
        });
      }
      sync();
      if (typeof compact.addEventListener === 'function') compact.addEventListener('change', sync);
      else if (typeof compact.addListener === 'function') compact.addListener(sync);
    });
  }

  /* ---------------- Nomad interactive sections ---------------- */

  function initNomadSections(scope) {
    qsa('[data-before-after]', scope || document).forEach(function (comparison) {
      if (comparison.hasAttribute('data-bound')) return;
      comparison.setAttribute('data-bound', '');
      var range = qs('[data-before-after-range]', comparison);
      if (!range) return;
      range.addEventListener('input', function () {
        comparison.style.setProperty('--reveal', range.value + '%');
      });
    });

  }

  /* ---------------- Page-level analytics ---------------- */

  function initDataEvents() {
    (document.body.getAttribute('data-events') || '').split(/\s+/).forEach(function (eventName) {
      if (!eventName) return;
      var payloadScript = qs('script[type="application/json"][data-event-payload="' + eventName + '"]');
      var payload = {};
      if (payloadScript) {
        try { payload = JSON.parse(payloadScript.textContent); } catch (err) {}
      }
      track(eventName, payload);
    });
  }

  /* ---------------- Boot ---------------- */

  function init() {
    initHeader();
    initDrawers();
    initCartMutations();
    initProductForms();
    initVariantPickers();
    initStickyAtc();
    initZoomTriggers();
    initCompatibility();
    initNomadSections();
    initFooter();
    initReveal();
    initDataEvents();

    fetchCart().then(function (cart) {
      cartCache = cart;
      updateCartCount(cart.item_count);
    }).catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Theme Editor: re-bind whatever the editor re-rendered. */
  document.addEventListener('shopify:section:load', function (event) {
    initHeader();
    initVariantPickers(event.target);
    initStickyAtc();
    initNomadSections(event.target);
    initFooter(event.target);
    initReveal(event.target);
  });
  document.addEventListener('shopify:section:unload', function (event) {
    var section = qs('[data-product-section]', event.target);
    if (section) boundSections.delete(section);
  });

  window.Roadnest.formatMoney = formatMoney;
  window.Roadnest.refreshCart = refreshDrawer;
})();
